module.exports = __webpack_public_path__ + "17e672b75e87329f2ddf60906cc89c01.svg";